import { render, staticRenderFns } from "./CambioGuiaCoordinacion.vue?vue&type=template&id=70c8a040&"
import script from "./CambioGuiaCoordinacion.vue?vue&type=script&lang=js&"
export * from "./CambioGuiaCoordinacion.vue?vue&type=script&lang=js&"
import style0 from "./CambioGuiaCoordinacion.vue?vue&type=style&index=0&id=70c8a040&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports